function capitalizeSegment(value) {
  const segment = String(value || '')
  return segment ? `${segment.charAt(0).toUpperCase()}${segment.slice(1)}` : ''
}

export function formatUserFacingBrand(value) {
  return String(value == null ? '' : value)
    .replace(/Fast\s+img/gi, 'FastIMG')
    .replace(/WintooAI\s+IMG/gi, 'FastIMG')
    .replace(/(?:Wintoo\s+)?GPT\s*Image\s*2(?:\s*Official)?/gi, 'FastIMG')
    .replace(/gpt-image-2(?:-official)?/gi, 'FastIMG')
    .replace(/(?:Wintoo\s+)?GPT/gi, 'Wintoo GPT')
}

export function formatModelName(value) {
  const model = String(value || '').trim()
  if (!model) return ''
  if (/^fast\s*img$/i.test(model)) return 'FastIMG'
  if (/^wintooai\s+img$/i.test(model)) return 'FastIMG'
  if (/^(?:wintoo\s+)?gpt\s*image\s*2(?:\s*official)?$/i.test(model)) return 'FastIMG'
  if (/^gpt-image-2(?:-official)?$/i.test(model)) return 'FastIMG'
  if (/^wintoo\s+gpt\b/i.test(model)) return model.replace(/^wintoo\s+gpt\b/i, 'Wintoo GPT')
  if (/^wintoo\s+/i.test(model)) return model.replace(/^wintoo\s+/i, 'Wintoo GPT ')

  const chatMatch = model.match(/^gpt-(.+)$/i)
  if (chatMatch) {
    const [version, ...variant] = chatMatch[1].split('-')
    const suffix = variant.length ? ` ${variant.map(capitalizeSegment).join(' ')}` : ''
    return `Wintoo GPT-${version}${suffix}`
  }

  return model
}
